<template>
    <div>
        <template v-if="_isMobile()">
            <div class="footerMenuBox">
                <a-row style="height: 100%;">
                    <a-col :span="8">
                        <p class="footerMenu" :class="[menuIndex == 1 ? 'footerMenuActive' : '']"
                            @click="switchMenu(1, '/index')">
                            <i class="iconfont">&#xe8c6;</i>
                            <span>首页</span>
                        </p>
                    </a-col>
                    <a-col :span="8">
                        <p class="footerMenu" :class="[menuIndex == 2 ? 'footerMenuActive' : '']"
                            @click="switchMenu(2, '/more')">
                            <i class="iconfont">&#xe602;</i>
                            <span>更多</span>
                        </p>
                    </a-col>
                    <a-col :span="8">
                        <p class="footerMenu" :class="[menuIndex == 3 ? 'footerMenuActive' : '']"
                            @click="switchMenu(3, '/mine')">
                            <i class="iconfont">&#xe8bb;</i>
                            <span>我的</span>
                        </p>
                    </a-col>
                </a-row>
            </div>
        </template>
        <template v-else>
            <div class="headerMenuBox">
                <a-row style="height: 100%;">
                    <a-col :span="12">
                        <p class="menuList" :class="[menuIndex == 1 ? 'menuListActive' : '']"
                            @click="switchMenu(1, '/index')">首页</p>
                        <p class="menuList" :class="[menuIndex == 2 ? 'menuListActive' : '']"
                            @click="switchMenu(2, '/more')">更多</p>
                    </a-col>
                    <a-col :span="12">
                        <div class="login-btn-wrap">

                            <span v-if="$store.state.user.info">
                                欢迎，<span @click="toCenter" style="padding-right: 10px;font-weight: bold;">{{
                                    $store.state.user.info.realname }}</span>
                                <a-avatar v-if="$store.state.user.info" @click="toCenter" icon="user" :src="avatarUrl" />
                                <a-divider type="vertical" />
                                <span @click="handleLogout">退出</span>
                            </span>
                            <span v-else>
                                <router-link :to="{ path: '/login' }">登录</router-link>
                                <!-- <a-divider type="vertical" />
                                <router-link :to="{ path: '/login' }">注册</router-link> -->
                            </span>
                        </div>
                    </a-col>
                </a-row>
            </div>
        </template>

    </div>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
import { mapActions } from "vuex";
export default {
    name: 'footerMenuBox',
    components: {},
    mixins: [mixinDevice],
    data() {
        return {
            menuIndex: 0
        }
    },
    computed: {
        avatarUrl() {
            if (this.$store.state.user.avatar) {
                return this.$store.state.user.avatar
            } else if (this.$store.state.user.info && this.$store.state.user.info.avatar) {
                return this.$store.state.user.info.avatar
            } else {
                return "/img/avatar.png"
            }
        }
    },
    watch: {
        $route: {
            handler(to, from) {
                this.menuIndex = to.meta.index
            },
            deep: true
        }
    },
    created() {
        console.log(this.$route)
        this.menuIndex = this.$route.meta.index
    },
    mounted() { },
    methods: {
        ...mapActions(["Logout"]),
        switchMenu(e, url) {
            this.menuIndex = e
            this.$router.push({ path: url })
        },
        toCenter() {
            this.$router.push({ path: '/mine' })
        },
        handleLogout() {
            const that = this;
            this.$confirm({
                title: "提示",
                content: "真的要注销登录吗 ?",
                onOk() {
                    return that
                        .Logout({})
                        .then(() => {
                            that.$router.push({ name: 'index' })
                            window.location.reload()
                        })
                        .catch((err) => {
                            that.$message.error({
                                title: "错误",
                                description: err.message,
                            });
                        });
                },
                onCancel() { },
            });
        },
    }
}
</script>
<style lang='less' scoped>
.headerMenuBox {
    width: 100%;
    height: 60px;
    padding: 0 50px;
    background: #fff;

    .menuList {
        cursor: pointer;
        line-height: 58px;
        float: left;
        padding: 0 30px;
        font-size: 14px;
        color: #333;
        font-weight: bold;
    }

    .menuListActive {
        color: #F75250;
        border-bottom: 2px solid #F75250;
    }

    .login-btn-wrap {
        cursor: pointer;
        height: 60px;
        text-align: right;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: end;

        /deep/.ant-input {
            background-color: transparent;
            color: white;
        }

        /deep/.ant-input-suffix {
            i {
                color: rgba(255, 255, 255, 0.82);
            }
        }

        .ant-avatar {
            margin-right: 5px;
        }

        a {
            color: #666;
        }

        .help {
            color: gray;
        }
    }
}

.footerMenuBox {
    width: 100%;
    height: 50px;
    background: #fff;
    box-shadow: 0 0 5px #ccc;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 99;

    .footerMenu {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 9px;
        color: #333;

        .iconfont {
            width: 25px;
            text-align: center;
            height: 25px;
            padding: 0 !important;
            font-size: 24px;
            line-height: 22px;
        }
    }

    .footerMenuActive {
        color: #F75250 !important;
    }
}
</style>
